// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"8c2f5706","542":"8c2f5706","733":"3847bb2d","873":"ab6b3a9f","977":"6cc47cbe"}[chunkId] + ".chunk.css";
};